import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { SparklesIcon } from "lucide-react";
import { trackCheckout } from "./metaPixel";
const CHECKOUT_URL = "https://aromaticos.impultienda.ar/checkout/artesanal";
export function FloatingCta({
  triggerId
}: {
  triggerId: string;
}) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const trigger = document.getElementById(triggerId);
    if (!trigger) return;
    const observer = new IntersectionObserver(([entry]) => setVisible(entry.boundingClientRect.top < 0), {
      threshold: 0
    });
    observer.observe(trigger);
    return () => observer.disconnect();
  }, [triggerId]);
  return <AnimatePresence data-id="element-216" data-mp="bpr931fdpff4">
      {visible && <motion.div initial={{
      y: 96,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 96,
      opacity: 0
    }} transition={{
      type: "spring",
      stiffness: 300,
      damping: 30
    }} className="fixed inset-x-0 bottom-0 z-50 px-3 pb-3" style={{
      paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))"
    }} data-id="element-217" data-mp="boycgta4w6ap">
          <a href={CHECKOUT_URL} onClick={trackCheckout} className="animate-pulse-glow mx-auto flex max-w-md items-center justify-center gap-2 rounded-full bg-[var(--mauve)] px-5 py-4 text-center text-sm font-bold uppercase tracking-wide text-white shadow-2xl ring-2 ring-white/70 transition-colors hover:bg-[var(--mauve-deep)] sm:text-base" data-id="element-218" data-mp="2f3ixix4w9n9t">
            <SparklesIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-219" data-mp="1wec8ksdibzfk" />
            Crear mi marca por $12,99 USD
          </a>
        </motion.div>}
    </AnimatePresence>;
}